var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-parent" }, [
    _c(
      "article",
      { staticClass: "tile is-child box" },
      [
        _c("repx-list", {
          attrs: {
            "hide-filter": _vm.hideFilter,
            "quote-id": _vm.value.quoteId,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }